<template>
  <div>
    <b-modal
      id="tank-enrollment-step-1"
      size="md"
      no-fade
      no-stacking
      centered
      no-close-on-esc
      no-close-on-backdrop
      @shown="activeModal = 'verify-tank-id'"
    >
      <template #modal-header>
        <b-row class="w-100" align-v="center" no-gutters>
          <b-col>
            <h2 class="modal-title" data-test-hook="tank-enrollment-step-1-header">
              <i class="colorOrange fas fa-plus mr-1" data-test-hook="tank-enrollment-step-1-header-icon"></i>
              {{ $t('xAddATank') }}
            </h2>
          </b-col>
          <b-col cols="auto">
            <b-button
              class="btn-icon-button"
              variant="icon-button--gray"
              @click="areYouSure('tank-enrollment-step-1')"
              data-test-hook="tank-enrollment-step-1-close-button"
            >
              <i class="fas fa-times" />
            </b-button>
          </b-col>
        </b-row>
      </template>
      <template #modal-footer>
        <b-button
          variant="primary"
          @click="validateDeviceId(), helpStep2++"
          :disabled="!validState($v.userEnteredTankDeviceId) || validatingId"
          data-test-hook="tank-enrollment-step-1-next-button"
        >
          {{ $t('xNext') }}
          <b-spinner class="ml-2" v-if="validatingId"></b-spinner>
        </b-button>
      </template>
      <b-row v-if="helpStep1 > 1">
        <b-col>
          <b-alert class="tu-help-alert" show>
            <b-row>
              <b-col>
                <h3>
                  <i class="fas fa-phone-alt" />
                  {{ $t('xNeedHelpContactSupport') }}
                </h3>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                {{ $t('xUsAndCanadaPhoneNumbers') }}
              </b-col>
            </b-row>
          </b-alert>
        </b-col>
      </b-row>
      <b-row align-v="center" class="mb-0">
        <b-col>
          <h5 data-test-hook="tank-enrollment-step-1-enter-tank-id-text">
            {{ $t('xEnterTankDeviceId') }}
          </h5>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group id="deviceId-group">
            <b-form-input
              id="deviceId"
              v-model="$v.userEnteredTankDeviceId.$model"
              autocomplete="new-password"
              :state="validState($v.userEnteredTankDeviceId) && validFuelMonitorId($v.userEnteredTankDeviceId.$model)"
              aria-describedby="deviceId-invalid"
              v-on:keyup.enter="validateDeviceId(), helpStep1++, helpStep2++"
              data-test-hook="tank-enrollment-step-1-tank-id-field"
            />
            <b-form-invalid-feedback id="deviceId-invalid">
              <span data-test-hook="tank-enrollment-step-1-invalid-tank-id">{{ $t('xYourTankDeviceIDMust') }}</span>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <div
        v-if="showValidateDeviceIdError"
        role="alert"
        class="alert alert--validation alert-danger"
        :show="showValidateDeviceIdError"
      >
        {{ validateDeviceIdErrorMessage }}
      </div>
      <b-row class="mt-5" align-v="center">
        <b-col class="mr-3 pr-0">
          <b-progress
            :value="11.11"
            variant="primary"
            data-test-hook="tank-enrollment-step-1-progress-bar"
          ></b-progress>
        </b-col>
      </b-row>
    </b-modal>

    <div>
      <b-modal
        id="tank-enrollment-step-2"
        size="md"
        no-fade
        centered
        no-stacking
        no-close-on-esc
        no-close-on-backdrop
        @shown="activeModal = 'enter-name-and-address'"
      >
        <template #modal-header>
          <b-row class="w-100" align-v="center" no-gutters>
            <b-col>
              <h2 class="modal-title" data-test-hook="tank-enrollment-step-2-header">
                <i class="colorOrange fas fa-plus mr-1" data-test-hook="tank-enrollment-step-2-header-icon"></i>
                {{ $t('xAddATank') }}
              </h2>
            </b-col>
            <b-col cols="auto">
              <b-button
                class="btn-icon-button"
                variant="icon-button--gray"
                @click="areYouSure('tank-enrollment-step-2')"
                data-test-hook="tank-enrollment-step-2-close-button"
              >
                <i class="fas fa-times" />
              </b-button>
            </b-col>
          </b-row>
        </template>
        <template #modal-footer>
          <b-button
            variant="outline-warning"
            @click="$bvModal.show('tank-enrollment-step-1'), (editingTankAddress = false), trackClick('VerifyTankName')"
            data-test-hook="tank-enrollment-step-2-previous-button"
          >
            {{ $t('xPrevious') }}
          </b-button>
          <b-button variant="primary" @click="onNext()" data-test-hook="tank-enrollment-step-2-next-button">
            <span v-if="!enrollingTank">{{ $t('xNext') }}</span>
            <b-spinner v-else />
          </b-button>
        </template>
        <b-row v-if="helpStep2 > 2">
          <b-col>
            <b-alert class="tu-help-alert" show>
              <b-row>
                <b-col>
                  <h3>
                    <i class="fas fa-phone-alt" />
                    {{ $t('xNeedHelpContactSupport') }}
                  </h3>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  {{ $t('xUsAndCanadaPhoneNumbers') }}
                </b-col>
              </b-row>
            </b-alert>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <h5 data-test-hook="tank-enrollment-step-2-verify-tank-name-text">{{ $t('xVerifyTankNameAndAddress') }}</h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <b-form-input
                id="tankTame"
                :placeholder="$t('xTankName')"
                maxLength="50"
                v-model="$v.tankName.$model"
                data-test-hook="tank-enrollment-step-2-tank-name-field"
                :state="validState($v.tankName) == null || validState($v.tankName) == true ? null : false"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-3" v-if="!editingTankAddress">
          <b-col>
            <p>
              <strong data-test-hook="tank-enrollment-step-2-tank-address-label">
                {{ 'xTankAddress' | formatLabel }}
              </strong>
            </p>
          </b-col>
        </b-row>
        <b-row v-if="!editingTankAddress">
          <b-col>
            <p data-test-hook="tank-enrollment-step-2-tank-address">{{ DisplayAddress(tankAddress) }}</p>
          </b-col>
          <b-col cols="auto">
            <b-button
              variant="icon-button"
              @click="openAddressSearchModal"
              data-test-hook="tank-enrollment-step-2-edit-address-button"
            >
              <i class="fas fa-pencil" />
            </b-button>
          </b-col>
        </b-row>
        <div
          v-if="showEnrollTankApparatusError"
          role="alert"
          class="alert alert--validation alert-danger"
          :show="showEnrollTankApparatusError"
        >
          {{ enrollTankApparatusErrorMessage }}
        </div>
        <b-row class="mt-5" align-v="center">
          <b-col class="mr-3 pr-0">
            <b-progress
              :value="22.22"
              variant="primary"
              data-test-hook="tank-enrollment-step-2-progress-bar"
            ></b-progress>
          </b-col>
        </b-row>
      </b-modal>
      <AddressSearchModals
        ref="tankEnrollmentAddressSearchModalsRef"
        addressSearchModalId="tank-enrollment-address-search-form"
        addressValidationModalId="tank-enrollment-address-validation-form"
        @onSubmit="updateFuelMonitorAddress"
        @onClose="onAddressValidationClose"
        :addressFormTitle="$t('xEditInformation')"
      />
    </div>

    <b-modal
      id="tank-enrollment-step-3"
      size="md"
      no-fade
      no-stacking
      centered
      no-close-on-esc
      no-close-on-backdrop
      @shown="activeModal = 'enter-fueltype-and-orientation'"
    >
      <template #modal-header>
        <b-row class="w-100" align-v="center" no-gutters>
          <b-col>
            <h2 class="modal-title" data-test-hook="tank-enrollment-step-3-header">
              <i class="colorOrange fas fa-plus mr-1" data-test-hook="tank-enrollment-step-3-header-icon"></i>
              {{ $t('xAddATank') }}
            </h2>
          </b-col>
          <b-col cols="auto">
            <b-button
              class="btn-icon-button"
              variant="icon-button--gray"
              @click="areYouSure('tank-enrollment-step-3')"
              data-test-hook="tank-enrollment-step-3-close-button"
            >
              <i class="fas fa-times" />
            </b-button>
          </b-col>
        </b-row>
      </template>
      <template #modal-footer>
        <b-button
          variant="primary"
          @click="loadTankCapacities(), helpStep4++"
          :disabled="userSelectedFuelType == null || userSelectedTankOrien == null"
          data-test-hook="tank-enrollment-step-3-next-button"
        >
          {{ $t('xNext') }}
          <b-spinner v-if="loadingTankCapacities" style="width: 1.5rem; height: 1.5rem" />
        </b-button>
      </template>
      <b-row v-if="helpStep3 > 2">
        <b-col>
          <b-alert class="tu-help-alert" show>
            <b-row>
              <b-col>
                <h3>
                  <i class="fas fa-phone-alt" />
                  {{ $t('xNeedHelpContactSupport') }}
                </h3>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                {{ $t('xUsAndCanadaPhoneNumbers') }}
              </b-col>
            </b-row>
          </b-alert>
        </b-col>
      </b-row>
      <b-row align-v="center" class="mb-0">
        <b-col>
          <h5 data-test-hook="tank-enrollment-step-3-enter-tank-details-text">
            {{ $t('xEnterYourTankDetails') }}
          </h5>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <p data-test-hook="tank-enrollment-step-3-select-fuel-type-text">{{ $t('xSelectYourFuelType') }}</p>
        </b-col>
      </b-row>
      <b-row class="w-100 mb-3" align-v="center" no-gutters>
        <b-col>
          <b-button-group class="w-100">
            <b-button
              @click=";(userSelectedFuelType = PROPANE), (userSelectedTankOrien = null)"
              :class="{ active: userSelectedFuelType == PROPANE }"
              variant="tank-outline"
              data-test-hook="tank-enrollment-step-3-fuel-type-propane-button"
            >
              {{ $t('xPropane') }}
            </b-button>
            <b-button
              @click=";(userSelectedFuelType = HEATINGOIL), (userSelectedTankOrien = HORIZONTAL)"
              :class="{ active: userSelectedFuelType == HEATINGOIL }"
              variant="tank-outline"
              data-test-hook="tank-enrollment-step-3-fuel-type-oil-button"
            >
              {{ $t('xOil') }}
            </b-button>
          </b-button-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <h6 data-test-hook="tank-enrollment-step-3-tank-orientation-text">{{ $t('xSelectTankOrien') }}</h6>
        </b-col>
      </b-row>
      <b-row class="w-100 mb-3" align-v="center" no-gutters>
        <b-col>
          <b-button
            style="height: 80px"
            block
            @click="userSelectedTankOrien = VERTICAL"
            class="py-0 mx-0"
            variant="tank-outline"
            :disabled="userSelectedFuelType == HEATINGOIL"
            :pressed="userSelectedTankOrien == VERTICAL"
            data-test-hook="tank-enrollment-step-3-tank-orientation-vertical-button"
          >
            <b-row align-v="center">
              <b-col>
                <b-img
                  v-if="userSelectedTankOrien == VERTICAL"
                  height="50px"
                  :src="require('@/assets/images/tank-vertical-selected.svg')"
                  data-test-hook="tank-enrollment-step-3-tank-orientation-vertical-image"
                />
                <b-img
                  v-if="
                    userSelectedTankOrien != VERTICAL &&
                      (userSelectedFuelType == PROPANE || userSelectedFuelType == null)
                  "
                  height="50px"
                  :src="require('@/assets/images/tank-vertical-unselected.svg')"
                  data-test-hook="tank-enrollment-step-3-tank-orientation-vertical-image"
                />
                <b-img
                  v-if="userSelectedFuelType == HEATINGOIL"
                  height="50px"
                  :src="require('@/assets/images/tank-vertical-disabled.svg')"
                  data-test-hook="tank-enrollment-step-3-tank-orientation-vertical-image"
                />
              </b-col>
              <b-col data-test-hook="tank-enrollment-step-3-tank-orientation-vertical-button-text">
                {{ $t('xVertical') }}
              </b-col>
              <b-col></b-col>
            </b-row>
          </b-button>
        </b-col>
      </b-row>
      <b-row class="w-100" align-v="center" no-gutters>
        <b-col>
          <b-button
            style="height: 80px"
            id="tank-orien-horz"
            block
            variant="tank-outline"
            @click="userSelectedTankOrien = HORIZONTAL"
            class="py-0 mx-0"
            :pressed="userSelectedFuelType == HEATINGOIL || userSelectedTankOrien == HORIZONTAL"
            data-test-hook="tank-enrollment-step-3-tank-orientation-horizontal-button"
          >
            <b-row align-v="center">
              <b-col>
                <b-img
                  v-if="userSelectedTankOrien == HORIZONTAL"
                  height="50px"
                  :src="require('@/assets/images/tank-horizontal-selected.svg')"
                  data-test-hook="tank-enrollment-step-3-tank-orientation-horizontal-image"
                />
                <b-img
                  v-else
                  height="50px"
                  :src="require('@/assets/images/tank-horizontal-unselected.svg')"
                  data-test-hook="tank-enrollment-step-3-tank-orientation-horizontal-image"
                />
              </b-col>
              <b-col data-test-hook="tank-enrollment-step-3-tank-orientation-horizontal-button-text">
                {{ $t('xHorizontal') }}
              </b-col>
              <b-col></b-col>
            </b-row>
          </b-button>
        </b-col>
      </b-row>
      <b-row class="mt-5" align-v="center">
        <b-col class="mr-3 pr-0">
          <b-progress
            :value="33.33"
            variant="primary"
            data-test-hook="tank-enrollment-step-3-progress-bar"
          ></b-progress>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      id="tank-enrollment-step-4"
      size="md"
      no-fade
      no-stacking
      centered
      no-close-on-esc
      no-close-on-backdrop
      @shown="activeModal = 'enter-capacity'"
    >
      <template #modal-header>
        <b-row class="w-100" align-v="center" no-gutters>
          <b-col>
            <h2 class="modal-title" data-test-hook="tank-enrollment-step-4-header">
              <i class="colorOrange fas fa-plus mr-1" data-test-hook="tank-enrollment-step-4-header-icon"></i>
              {{ $t('xAddATank') }}
            </h2>
          </b-col>
          <b-col cols="auto">
            <b-button
              class="btn-icon-button"
              variant="icon-button--gray"
              @click="areYouSure('tank-enrollment-step-4')"
              data-test-hook="tank-enrollment-step-4-close-button"
            >
              <i class="fas fa-times" />
            </b-button>
          </b-col>
        </b-row>
      </template>
      <template #modal-footer>
        <b-button
          variant="outline-warning"
          @click="$bvModal.show('tank-enrollment-step-3'), trackClick('SelectTankCapacity'), helpStep3++"
          data-test-hook="tank-enrollment-step-4-previous-button"
        >
          {{ $t('xPrevious') }}
        </b-button>
        <b-button
          variant="primary"
          @click="wifiSetupNavigation()"
          :disabled="userSelectedTankCapacity == null"
          data-test-hook="tank-enrollment-step-4-next-button"
        >
          {{ $t('xNext') }}
        </b-button>
      </template>
      <b-row v-if="helpStep4 > 2">
        <b-col>
          <b-alert class="tu-help-alert" show>
            <b-row>
              <b-col>
                <h3>
                  <i class="fas fa-phone-alt" />
                  {{ $t('xNeedHelpContactSupport') }}
                </h3>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                {{ $t('xUsAndCanadaPhoneNumbers') }}
              </b-col>
            </b-row>
          </b-alert>
        </b-col>
      </b-row>
      <b-row align-v="center" class="mb-0">
        <b-col>
          <h5 data-test-hook="tank-enrollment-step-4-select-tank-capacity-text">
            {{ $t('xSelectYourTankCapacity') }}
          </h5>
        </b-col>
      </b-row>
      <div class="row">
        <div class="col">
          <fieldset id="tank-capacity-group" class="form-group">
            <select
              class="custom-select"
              id="tank-capacity"
              v-model="$v.userSelectedTankCapacity.$model"
              :placeholder="$t('xSelectCapacity')"
              :state="validState($v.userSelectedTankCapacity)"
              aria-describedby="capacity-invalid"
              data-test-hook="tank-enrollment-step-4-tank-capacity-field"
            >
              <option v-if="!userSelectedTankCapacity" :value="null" disabled></option>
              <option
                v-for="(capacity, index) in tankCapacities"
                :key="index"
                :value="capacity.value"
                :data-test-hook="'tankCapacity' + userSelectedFuelType + userSelectedTankOrien + capacity.value"
              >
                {{ capacity.text }}
              </option>
            </select>
            <b-form-invalid-feedback id="capacity-invalid"> {{ $t('xRequiredField') }}. </b-form-invalid-feedback>
          </fieldset>
        </div>
      </div>
      <b-row class="w-100 mb-3" align-v="center" no-gutters>
        <b-col> </b-col>
      </b-row>
      <b-row class="mt-5" align-v="center">
        <b-col class="mr-3 pr-0">
          <b-progress
            :value="44.44"
            variant="primary"
            data-test-hook="tank-enrollment-step-4-progress-bar"
          ></b-progress>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      id="tank-enrollment-step-5"
      size="md"
      no-fade
      no-stacking
      centered
      no-close-on-esc
      no-close-on-backdrop
      @shown="activeModal = 'confirm-tank-install'"
    >
      <template #modal-header>
        <b-row class="w-100" align-v="center" no-gutters>
          <b-col>
            <h2 class="modal-title" data-test-hook="tank-enrollment-step-5-header">
              <i class="colorOrange fas fa-plus mr-1" data-test-hook="tank-enrollment-step-5-header-icon"></i>
              {{ $t('xAddATank') }}
            </h2>
          </b-col>
          <b-col cols="auto">
            <b-button
              class="btn-icon-button"
              variant="icon-button--gray"
              @click="areYouSure('tank-enrollment-step-5')"
              data-test-hook="tank-enrollment-step-5-close-button"
            >
              <i class="fas fa-times" />
            </b-button>
          </b-col>
        </b-row>
      </template>
      <template #modal-footer>
        <b-button
          variant="outline-warning"
          @click="$bvModal.show('tank-enrollment-step-4'), trackClick('ConfirmMonitorInstallation'), helpStep4++"
          data-test-hook="tank-enrollment-step-5-previous-button"
        >
          {{ $t('xPrevious') }}
        </b-button>
        <b-button
          variant="primary"
          @click="$bvModal.show('tank-enrollment-step-6'), helpStep6++, (getTankReadingCancelled = false)"
          data-test-hook="tank-enrollment-step-5-next-button"
        >
          {{ $t('xNext') }}
        </b-button>
      </template>
      <b-row v-if="helpStep5 > 2">
        <b-col>
          <b-alert class="tu-help-alert" show>
            <b-row>
              <b-col>
                <h3>
                  <i class="fas fa-phone-alt" />
                  {{ $t('xNeedHelpContactSupport') }}
                </h3>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                {{ $t('xUsAndCanadaPhoneNumbers') }}
              </b-col>
            </b-row>
          </b-alert>
        </b-col>
      </b-row>
      <b-row class="my-0">
        <b-col>
          <b-embed
            type="iframe"
            :src="tankMonitorInstallVideoUrl()"
            allowfullscreen
            data-test-hook="tank-enrollment-step-5-monitor-install-video"
          ></b-embed>
        </b-col>
      </b-row>
      <b-row class="mb-0 mt-3">
        <b-col>
          <h5 data-test-hook="tank-enrollment-step-5-confirm-monitor-install-text">
            {{ $t('xConfirmTankMonitorInstallation') }}
          </h5>
          <ul class="mt-3 bullet-points">
            <li data-test-hook="tank-enrollment-step-5-sensor-attached-text">
              {{ $t('xEnsureTankMonitorSensorIsAttached') }}
            </li>
            <li data-test-hook="tank-enrollment-step-5-magnet-to-trigger-reading-text">
              {{ $t('xUseTheMagnetToTriggerAReading') }}
            </li>
            <li data-test-hook="tank-enrollment-step-5-you-will-know-text">
              {{ $t('xYouWillKnowAReading') }}
            </li>
            <li data-test-hook="tank-enrollment-step-5-tap-next-to-continue-text">
              {{ $t('xTapNextBelowToContinue') }}
            </li>
          </ul>
        </b-col>
      </b-row>
      <div v-if="showTankReadingError" :show="showTankReadingError" class="alert alert-danger alert--validation">
        {{ tankReadingErrorMessage }}
      </div>
      <b-row align-v="center">
        <b-col class="mr-3 pr-0">
          <b-progress
            :value="55.55"
            variant="primary"
            data-test-hook="tank-enrollment-step-5-progress-bar"
          ></b-progress>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      id="tank-enrollment-step-6"
      size="md"
      hide-footer
      no-fade
      no-stacking
      centered
      no-close-on-esc
      no-close-on-backdrop
      @shown=";(activeModal = 'wait-for-tank-reading'), getTankReading()"
    >
      <template #modal-header>
        <b-row class="w-100" align-v="center" no-gutters>
          <b-col>
            <h2 class="modal-title" data-test-hook="tank-enrollment-step-6-header">
              <i class="colorOrange fas fa-plus mr-1" data-test-hook="tank-enrollment-step-6-header-icon"></i>
              {{ $t('xAddATank') }}
            </h2>
          </b-col>
          <b-col cols="auto">
            <b-button
              class="btn-icon-button"
              variant="icon-button--gray"
              @click="areYouSure('tank-enrollment-step-6')"
              data-test-hook="tank-enrollment-step-6-close-button"
            >
              <i class="fas fa-times" />
            </b-button>
          </b-col>
        </b-row>
      </template>
      <b-row v-if="helpStep6 > 2">
        <b-col>
          <b-alert class="tu-help-alert" show>
            <b-row>
              <b-col>
                <h3>
                  <i class="fas fa-phone-alt" />
                  {{ $t('xNeedHelpContactSupport') }}
                </h3>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                {{ $t('xUsAndCanadaPhoneNumbers') }}
              </b-col>
            </b-row>
          </b-alert>
        </b-col>
      </b-row>
      <b-row align-v="center">
        <b-col>
          <h5 class="text-center" data-test-hook="tank-enrollment-step-6-wait-for-reading-text">
            {{ $t('xPleaseWaitForYourTankMonitorToReceiveAReading') }}
          </h5>
        </b-col>
      </b-row>
      <b-row no-gutters>
        <b-col>
          <lottie
            :options="waitingForTankReadingAnimationOptions"
            v-on:animCreated="handleAnimation"
            :height="200"
            :width="200"
            data-test-hook="tank-enrollment-step-6-wait-for-reading-animation"
          />
        </b-col>
      </b-row>
      <b-row
        align-h="center"
        class="shouldnt-take-long"
        data-test-hook="tank-enrollment-step-6-shouldnt-take-long-text"
      >
        {{ $t('xThisShouldntTakeLong') }}
      </b-row>
    </b-modal>

    <b-modal
      id="tank-enrollment-step-7"
      size="md"
      no-fade
      no-stacking
      centered
      no-close-on-esc
      no-close-on-backdrop
      @shown="activeModal = 'tank-reading-received'"
    >
      <template #modal-header>
        <b-row class="w-100" align-v="center" no-gutters>
          <b-col>
            <h2 class="modal-title" data-test-hook="tank-enrollment-step-7-header">
              <i class="colorOrange fas fa-plus mr-1" data-test-hook="tank-enrollment-step-7-header-icon"></i>
              {{ $t('xAddATank') }}
            </h2>
          </b-col>
          <b-col cols="auto">
            <b-button
              class="btn-icon-button"
              variant="icon-button--gray"
              @click="areYouSure('tank-enrollment-step-7')"
              data-test-hook="tank-enrollment-step-7-close-button"
            >
              <i class="fas fa-times" />
            </b-button>
          </b-col>
        </b-row>
      </template>
      <template #modal-footer>
        <b-button
          variant="outline-warning"
          @click="$bvModal.show('tank-enrollment-step-8'), helpStep8++"
          data-test-hook="tank-enrollment-step-7-verify-reading-button"
        >
          {{ $t('xVerifyTankReading') }}
        </b-button>
        <b-button
          variant="primary"
          @click="$bvModal.show('tank-enrollment-step-9'), helpStep9++"
          data-test-hook="tank-enrollment-step-7-looks-good-button"
        >
          {{ $t('xLooksGood') }}
        </b-button>
      </template>
      <b-row v-if="helpStep7 > 2">
        <b-col>
          <b-alert class="tu-help-alert" show>
            <b-row>
              <b-col>
                <h3>
                  <i class="fas fa-phone-alt" />
                  {{ $t('xNeedHelpContactSupport') }}
                </h3>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                {{ $t('xUsAndCanadaPhoneNumbers') }}
              </b-col>
            </b-row>
          </b-alert>
        </b-col>
      </b-row>
      <b-row align-v="center">
        <b-col>
          <h1 class="text-center" data-test-hook="tank-enrollment-step-7-reading-received-text">
            {{ $t('xReadingReceived') }}
          </h1>
        </b-col>
      </b-row>
      <b-row align-h="center" class="my-2">
        <b-col
          cols="auto"
          style="font-size: 6rem; padding-right: 5px"
          class="colorGray"
          data-test-hook="tank-enrollment-step-7-tank-level"
        >
          {{ tankReadingLevel }}
        </b-col>
        <b-col cols="auto" style="font-size: 3rem; padding-top: 25px; margin-top: 0px" class="pl-0 colorGray">%</b-col>
      </b-row>
      <b-row align-h="center" class="shouldnt-take-long">
        {{ $t('xCurrentTankReading') }}
      </b-row>
      <b-row align-h="center" class="mt-3 mb-2 mx-3 verify-reading">
        <p>{{ $t('xIfThisReadingDoesntLookRight') }}</p>
      </b-row>
      <b-row align-v="center">
        <b-col class="mr-3 pr-0">
          <b-progress
            :value="66.66"
            variant="primary"
            data-test-hook="tank-enrollment-step-7-progress-bar"
          ></b-progress>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      id="tank-enrollment-step-8"
      size="md"
      no-fade
      no-stacking
      centered
      no-close-on-esc
      no-close-on-backdrop
      @shown="activeModal = 'user-verify-tank-reading'"
    >
      <template #modal-header>
        <b-row class="w-100" align-v="center" no-gutters>
          <b-col>
            <h2 class="modal-title" data-test-hook="tank-enrollment-step-8-header">
              <i class="colorOrange fas fa-plus mr-1" data-test-hook="tank-enrollment-step-8-header-icon"></i>
              {{ $t('xAddATank') }}
            </h2>
          </b-col>
          <b-col cols="auto">
            <b-button
              class="btn-icon-button"
              variant="icon-button--gray"
              @click="areYouSure('tank-enrollment-step-8')"
              data-test-hook="tank-enrollment-step-8-close-button"
            >
              <i class="fas fa-times" />
            </b-button>
          </b-col>
        </b-row>
      </template>
      <template #modal-footer v-if="verifyTankReadingSuccess == false">
        <b-button
          variant="outline-warning"
          @click="$bvModal.show('tank-enrollment-step-9'), helpStep9++"
          data-test-hook="tank-enrollment-step-8-try-later-button"
        >
          {{ $t('xTryLater') }}
        </b-button>
        <b-button
          variant="primary"
          @click="tryEnterTankLevelAgain"
          :disabled="!tankLevelValidationDone"
          data-test-hook="tank-enrollment-step-8-try-again-button"
        >
          <span>{{ $t('xTryAgain') }}</span>
        </b-button>
      </template>
      <template #modal-footer v-else>
        <b-button
          variant="outline-warning"
          @click="$bvModal.show('tank-enrollment-step-7'), trackClick('Verify-Tank-Level-Reading'), helpStep7++"
          data-test-hook="tank-enrollment-step-8-previous-button"
        >
          {{ $t('xPrevious') }}
        </b-button>
        <b-button
          variant="primary"
          @click="$bvModal.show('tank-enrollment-step-9'), helpStep9++"
          :disabled="!tankLevelValidationDone"
          data-test-hook="tank-enrollment-step-8-next-button"
        >
          <span>{{ $t('xNext') }}</span>
        </b-button>
      </template>
      <b-row v-if="helpStep8 > 2">
        <b-col>
          <b-alert class="tu-help-alert" show>
            <b-row>
              <b-col>
                <h3 data-test-hook="tank-enrollment-step-8-help-alert">
                  <i class="fas fa-phone-alt" />
                  {{ $t('xNeedHelpContactSupport') }}
                </h3>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                {{ $t('xUsAndCanadaPhoneNumbers') }}
              </b-col>
            </b-row>
          </b-alert>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div v-if="verifyTankReadingSuccess == null">
            <h5>
              <span data-test-hook="tank-enrollment-step-8-body-header">
                {{ $t('xEnterYourCurrentTankLevel') }}
              </span>
            </h5>
            <p data-test-hook="tank-enrollment-step-8-body-text">{{ $t('xWhileStandingNextToYourTank') }}</p>
          </div>
          <b-alert v-if="verifyTankReadingSuccess == true" show variant="success">
            <h5 data-test-hook="tank-enrollment-step-8-success-header">
              <i class="colorGreen fas fa-check-circle mr-1"></i>{{ $t('xSuccess') }}
            </h5>
            <b-row class="ml-0">
              <span data-test-hook="tank-enrollment-step-8-success-body">
                {{ $t('xYourTankMonitorIsProperlyInstalled') }}
              </span>
            </b-row>
          </b-alert>
        </b-col>
      </b-row>
      <div v-if="verifyTankReadingSuccess == false">
        <b-alert show variant="danger">
          <h5 data-test-hook="tank-enrollment-step-8-error-header">
            <i class="colorRed fas fa-exclamation-triangle mr-1" />{{ $t('xError') }}
          </h5>
          <b-row class="ml-0">
            <span data-test-hook="tank-enrollment-step-8-error-body">
              {{ $t('xThereWasAnErrorVerifyingYourTankReading') }}
            </span>
          </b-row>
        </b-alert>
        <b-row class="ml-1 mt-2">
          <b data-test-hook="tank-enrollment-step-8-best-results-header">{{ $t('xForBestResults') }}</b>
        </b-row>
        <ul class="bullet-points mr-1">
          <li data-test-hook="tank-enrollment-step-8-best-results-help1">
            {{ $t('xEnsureTankMonitorSensorIsAttached') }}
          </li>
          <li data-test-hook="tank-enrollment-step-8-best-results-help2">{{ $t('xUseTheMagnetToTriggerAReading') }}</li>
        </ul>
      </div>
      <b-row class="mt-4 bold-text">
        <b-col class="text-center">
          {{ $t('xTankDialLevel') }}
        </b-col>
        <b-col class="text-center">
          {{ $t('xTankMonitorReading') }}
        </b-col>
      </b-row>
      <b-row class="mt-2 mb-2">
        <b-col cols="6" class="d-flex align-items-center">
          <b-input-group id="tankDialLevel-group" append="%">
            <b-form-input
              id="tankDialLevel"
              v-model="$v.userEnteredTankDialLevel.$model"
              type="text"
              size="lg"
              autofocus
              :state="validState($v.userEnteredTankDialLevel)"
              aria-describedby="tankDialLevel-invalid"
              v-mask="'##'"
              @keydown="verifyTankReadingSuccess = null"
              data-test-hook="tank-enrollment-step-8-dial-level-field"
            />
            <b-form-invalid-feedback id="tankDialLevel-invalid">
              {{ $t('xEnterValueDisplayedOnTankDial') }}
            </b-form-invalid-feedback>
          </b-input-group>
        </b-col>
        <b-col cols="6" class="text-center">
          <b-input-group id="tankReadingLevel-group" append="%">
            <b-form-input
              id="tankReadingLevel"
              type="text"
              size="lg"
              disabled
              autofocus
              :value="tankReadingLevel"
              data-test-hook="tank-enrollment-step-8-tank-reading-level-field"
            />
          </b-input-group>
        </b-col>
        <b-col cols="auto" class="mt-3 pl-0"></b-col>
      </b-row>
      <b-row class="mb-3" v-if="!verifyTankReadingSuccess">
        <b-col>
          <b-button
            block
            variant="primary"
            @click="verifyTankReading(), (tankLevelValidationDone = true)"
            :disabled="!userEnteredTankDialLevel || userEnteredTankDialLevel < 1 || userEnteredTankDialLevel > 100"
            data-test-hook="tank-enrollment-step-8-verify-button"
          >
            <span>{{ $t('xVerify') }}</span>
          </b-button>
        </b-col>
      </b-row>
      <b-row align-v="center">
        <b-col class="mr-3 pr-0">
          <b-progress
            :value="77.77"
            variant="primary"
            data-test-hook="tank-enrollment-step-8-progress-bar"
          ></b-progress>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      id="tank-enrollment-step-9"
      size="md"
      no-fade
      no-stacking
      centered
      no-close-on-esc
      no-close-on-backdrop
      @shown="activeModal = 'specify-tank-usage'"
    >
      <template #modal-header>
        <b-row class="w-100" align-v="center" no-gutters>
          <b-col>
            <h2 class="modal-title" data-test-hook="tank-enrollment-step-9-header">
              <i class="colorOrange fas fa-plus mr-1" data-test-hook="tank-enrollment-step-9-header-icon"></i>
              {{ $t('xAddATank') }}
            </h2>
          </b-col>
          <b-col cols="auto">
            <b-button
              class="btn-icon-button"
              variant="icon-button--gray"
              @click="areYouSure('tank-enrollment-step-9')"
              data-test-hook="tank-enrollment-step-9-close-button"
            >
              <i class="fas fa-times" />
            </b-button>
          </b-col>
        </b-row>
      </template>
      <template #modal-footer>
        <b-button
          v-if="tankDeviceType && tankDeviceType != wifiTankDeviceType"
          variant="outline-warning"
          @click="
            ;(userEnteredTankDeviceId = null),
              (verifyTankReadingSuccess = null),
              $bvModal.show('tank-enrollment-step-7'),
              helpStep7++
          "
          data-test-hook="tank-enrollment-step-9-previous-button"
        >
          {{ $t('xPrevious') }}
        </b-button>
        <b-button
          variant="primary"
          @click="checkFuelUseSelected(), helpStep10++"
          data-test-hook="tank-enrollment-step-9-next-button"
        >
          <span>{{ $t('xNext') }}</span>
        </b-button>
      </template>
      <b-row v-if="helpStep9 > 2">
        <b-col>
          <b-alert class="tu-help-alert" show>
            <b-row>
              <b-col>
                <h3>
                  <i class="fas fa-phone-alt" />
                  {{ $t('xNeedHelpContactSupport') }}
                </h3>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                {{ $t('xUsAndCanadaPhoneNumbers') }}
              </b-col>
            </b-row>
          </b-alert>
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col cols="auto" class="pr-0 pb-0">
          <p v-html="$t('xWhichDevicesConsumeFuel')" />
        </b-col>
      </b-row>
      <b-row class="mb-2" align-v="center" v-for="(type, index) in selectedTankUtilFuelUses" :key="index">
        <b-col align-v="center" :data-test-hook="'fuelUse-' + removeExtraChars($t(type.name)) + '-Header'">
          {{ $t(type.name) }}
        </b-col>
        <b-col cols="auto">
          <b-button
            class="mr-2"
            pill
            variant="outline-primary"
            @click="addTag(index, true)"
            :pressed="type.selected != null && type.selected"
            :data-test-hook="'fuelUse-' + removeExtraChars($t(type.name)) + '-YesBtn'"
          >
            {{ $t('xYes') }}
          </b-button>
          <b-button
            pill
            variant="outline-primary"
            @click="addTag(index, false)"
            :pressed="type.selected != null && !type.selected"
            :data-test-hook="'fuelUse-' + removeExtraChars($t(type.name)) + '-NoBtn'"
          >
            {{ $t('xNo') }}
          </b-button>
        </b-col>
      </b-row>
      <b-row v-if="showTankUsageUnfinishedErrorMessage" class="mt-2 mb-2">
        <b-col>
          <p data-test-hook="tank-enrollment-step-9-unfinished-message" class="colorRed">
            {{ $t('xTankUsageUnfinishedErrorMessage') }}
          </p>
        </b-col>
      </b-row>
      <b-row align-v="center">
        <b-col class="mr-3 pr-0">
          <b-progress
            :value="88.88"
            variant="primary"
            data-test-hook="tank-enrollment-step-9-progress-bar"
          ></b-progress>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      id="tank-enrollment-step-10"
      size="md"
      no-fade
      no-stacking
      centered
      no-close-on-esc
      no-close-on-backdrop
      @shown="activeModal = 'specify-fuel-provider'"
    >
      <template #modal-header>
        <b-row class="w-100" align-v="center" no-gutters>
          <b-col>
            <h2 class="modal-title" data-test-hook="tank-enrollment-step-10-header">
              <i class="colorOrange fas fa-plus mr-1" data-test-hook="tank-enrollment-step-10-header-icon"></i>
              {{ $t('xAddATank') }}
            </h2>
          </b-col>
          <b-col cols="auto">
            <b-button
              class="btn-icon-button--gray"
              variant="icon-button"
              @click="areYouSure('tank-enrollment-step-10')"
              data-test-hook="tank-enrollment-step-10-close-button"
            >
              <i class="fas fa-times" />
            </b-button>
          </b-col>
        </b-row>
      </template>
      <template #modal-footer>
        <b-button
          variant="outline-warning"
          @click="$bvModal.show('tank-enrollment-step-9'), trackClick('tank-enrollment-step-10'), helpStep9++"
          data-test-hook="tank-enrollment-step-10-previous-button"
        >
          {{ $t('xPrevious') }}
        </b-button>
        <b-button
          @click="finishSetup()"
          variant="primary"
          :disabled="finishingSetup"
          data-test-hook="tank-enrollment-step-10-finish-button"
        >
          <span v-if="finishingSetup"><b-spinner /></span>
          <span v-else>{{ $t('xFinishSetup') }}</span>
        </b-button>
      </template>
      <b-row v-if="helpStep10 > 2">
        <b-col>
          <b-alert class="tu-help-alert" show>
            <b-row>
              <b-col>
                <h3>
                  <i class="fas fa-phone-alt" />
                  {{ $t('xNeedHelpContactSupport') }}
                </h3>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                {{ $t('xUsAndCanadaPhoneNumbers') }}
              </b-col>
            </b-row>
          </b-alert>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="auto" class="pb-0 pr-0">
          <h5 class="mb-0 pb-0" data-test-hook="tank-enrollment-step-10-who-delivers-fuel-text">
            {{ $t('xWhoDeliversYourFuel') }}
          </h5>
        </b-col>
      </b-row>
      <b-form-group id="fuelprovider-group">
        <span v-click-outside="hideResults">
          <b-input-group>
            <b-form-input
              v-model="freeformFuelProvider"
              type="text"
              v-on:keyup="typeAheadSearch()"
              autocomplete="new-password"
              data-test-hook="tank-enrollment-step-10-fuel-dealer-search-field"
            >
            </b-form-input>
            <b-input-group-append>
              <b-button
                class="my-0 py-0"
                variant="warning"
                @click="!awaitingSearch ? typeAheadSearch() : null"
                data-test-hook="tank-enrollment-step-10-fuel-dealer-search-button"
              >
                <b-spinner v-if="awaitingSearch" style="width: 1.5rem; height: 1.5rem" />
                <i v-else class="fas fa-search" />
              </b-button>
            </b-input-group-append>
          </b-input-group>
          <b-row> </b-row>
          <b-row>
            <b-col>
              <b-list-group class="suggested-input-list" v-if="fuelProviderResults">
                <b-list-group-item
                  class="hoverPointer"
                  v-for="(provider, index) in fuelProviderResults"
                  :key="index"
                  @click="setFuelProvider(provider)"
                  :data-test-hook="'FuelProviderSuggestion-' + removeExtraChars(provider.name)"
                >
                  {{ provider.name }}
                </b-list-group-item>
              </b-list-group>
            </b-col>
          </b-row>
          <b-row class="mt-3" v-if="fuelProviderName">
            <b-col data-test-hook="tank-enrollment-step-10-selected-fuel-dealer">{{ fuelProviderName }}</b-col>
          </b-row>
        </span>
      </b-form-group>
      <div v-if="showFinishSetupError" :show="showFinishSetupError" class="alert alert-danger alert--validation">
        {{ finishSetupErrorMessage }}
      </div>
      <b-row align-v="center">
        <b-col class="mr-3 pr-0">
          <b-progress
            :value="88.88"
            variant="primary"
            data-test-hook="tank-enrollment-step-10-progress-bar"
          ></b-progress>
        </b-col>
      </b-row>
    </b-modal>

    <SubscriptionsModal
      modal-id="subscription-modal-tank"
      :apparatus-id="tankApparatusId"
      :apparatus-list="apparatuses"
      :account-profile="accountProfile"
      @setSubscriptionPollingInfo="setSubscriptionPollingInfo"
    />

    <b-modal id="tank-enrollment-success" size="md" no-fade no-stacking centered no-close-on-esc no-close-on-backdrop>
      <template #modal-header>
        <b-row class="w-100" align-v="center" no-gutters>
          <b-col>
            <h2 class="modal-title" data-test-hook="tank-enrollment-success-title">
              <i class="colorOrange far fa-badge-dollar mr-1" data-test-hook="tank-enrollment-success-title-icon"></i>
              {{ $t('xCongratulations') + '!' }}
            </h2>
          </b-col>
        </b-row>
      </template>
      <template #modal-footer>
        <b-button
          variant="warning"
          @click="closeEnrollmentModals()"
          data-test-hook="tank-enrollment-success-go-to-dashboard-button"
        >
          {{ $t('xReturnToDashboard') }}
        </b-button>
      </template>
      <b-row class="text-center mt-2 mb-2">
        <b-col>
          <p data-test-hook="tank-enrollment-success-body-header">
            {{ $t('xYourTankIsSubscribedForPremiumRemoteMonitoring') }}
          </p>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      id="tank-enrollment-tank-reading-not-received"
      size="md"
      no-fade
      no-stacking
      centered
      no-close-on-esc
      no-close-on-backdrop
    >
      <template #modal-header>
        <b-row class="w-100" align-v="center" no-gutters>
          <b-col>
            <h2 class="modal-title" data-test-hook="tank-enrollment-tank-reading-not-received-header">
              <i
                class="colorOrange fas fa-plus mr-1"
                data-test-hook="tank-enrollment-tank-reading-not-received-header-icon"
              ></i>
              {{ $t('xAddATank') }}
            </h2>
          </b-col>
          <b-col cols="auto">
            <b-button
              class="btn-icon-button--gray"
              variant="icon-button"
              @click="areYouSure('tank-enrollment-tank-reading-not-received')"
              data-test-hook="tank-enrollment-tank-reading-not-received-close-button"
            >
              <i class="fas fa-times" />
            </b-button>
          </b-col>
        </b-row>
      </template>
      <template #modal-footer>
        <b-row class="w-100">
          <b-col>
            <b-button
              block
              variant="warning"
              @click="$bvModal.show('tank-enrollment-step-6'), helpStep6++, (getTankReadingCancelled = false)"
              data-test-hook="tank-enrollment-tank-reading-not-received-try-again-button"
            >
              {{ $t('xTryAgain') }}
            </b-button>
          </b-col>
        </b-row>
        <b-row class="w-100">
          <b-col>
            <b-button
              block
              variant="outline-warning"
              @click="$bvModal.show('tank-enrollment-step-5'), helpStep5++, (getTankReadingCancelled = false)"
              data-test-hook="tank-enrollment-tank-reading-not-received-confirm-install-button"
            >
              {{ $t('xConfirmInstallation') }}
            </b-button>
          </b-col>
        </b-row>
      </template>
      <b-row v-if="helpReadingNotReceived > 2">
        <b-col>
          <b-alert class="tu-help-alert" show>
            <b-row>
              <b-col>
                <h3>
                  <i class="fas fa-phone-alt" />
                  {{ $t('xNeedHelpContactSupport') }}
                </h3>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                {{ $t('xUsAndCanadaPhoneNumbers') }}
              </b-col>
            </b-row>
          </b-alert>
        </b-col>
      </b-row>
      <b-row align-v="center">
        <b-col>
          <h5 class="text-center" data-test-hook="tank-enrollment-tank-reading-not-received-no-reading-text">
            {{ $t('xTankReadingNotReceived') }}
          </h5>
        </b-col>
      </b-row>
      <b-row align-h="center" class="mt-2 mb-2">
        <b-col cols="auto">
          <i class="colorOrange far fa-sad-tear fa-2x"></i>
        </b-col>
      </b-row>
      <b-row align-h="center" class="mt-4 ml-1 mr-1 check-cellular">
        {{ $t('xPleaseCheckYourCellularConnection') }}
      </b-row>
    </b-modal>

    <b-modal id="wifi-tank-setup" size="md" no-fade no-stacking centered no-close-on-esc no-close-on-backdrop>
      <template #modal-header>
        <b-row class="w-100" align-v="center" no-gutters>
          <b-col>
            <h2 class="modal-title" data-test-hook="wifi-tank-setup-header">
              <i class="colorOrange fas fa-plus mr-1" data-test-hook="wifi-tank-setup-header-icon"></i>
              {{ $t('xAddATank') }}
            </h2>
          </b-col>
          <b-col cols="auto">
            <b-button
              class="btn-icon-button--gray"
              variant="icon-button"
              @click="$bvModal.hide('wifi-tank-setup'), resetInfo()"
              data-test-hook="wifi-tank-setup-close-button"
            >
              <i class="fas fa-times" />
            </b-button>
          </b-col>
        </b-row>
      </template>
      <template #modal-footer>
        <b-button
          variant="warning"
          block
          @click="$bvModal.hide('wifi-tank-setup'), resetInfo()"
          data-test-hook="wifi-tank-setup-ok-button"
        >
          {{ $t('xOK') }}
        </b-button>
      </template>
      <b-row>
        <b-col>
          <h4>{{ $t('xWifiTankSetup') }}</h4>
        </b-col>
      </b-row>
      <b-row>
        <b-col v-html="$t('xWifiTankSetupMessage')" data-test-hook="wifi-tank-setup-message"></b-col>
      </b-row>
    </b-modal>

    <b-modal id="confirm-close-wizard" size="md" centered no-close-on-backdrop no-close-on-esc>
      <template #modal-header>
        <b-row class="w-100" align-v="center" no-gutters>
          <b-col>
            <h2 class="modal-title" data-test-hook="confirm-close-wizard-header">
              <i
                class="fas fa-exclamation-triangle colorOrange mr-1"
                data-test-hook="confirm-close-wizard-header-icon"
              />
              {{ $t('xAreYouSure') }}
            </h2>
          </b-col>
        </b-row>
      </template>
      <b-row class="mt-1" style="font-size: 1rem">
        <b-col data-test-hook="confirm-close-wizard-are-you-sure-text">
          {{ $t('xAreYouSureYouWantToExitBeforeFinishing') }}
        </b-col>
      </b-row>
      <b-row class="mt-2 checkbox-row" no-gutters> </b-row>
      <template #modal-footer>
        <b-button
          variant="outline-warning"
          @click="$bvModal.hide('confirm-close-wizard'), $bvModal.show(currentWizardWindow)"
          data-test-hook="confirm-close-wizard-cancel-button"
        >
          {{ $t('xNoCancel') }}
        </b-button>
        <b-button
          variant="primary"
          @click="closeEnrollmentModals()"
          data-test-hook="confirm-close-wizard-confirm-button"
        >
          {{ $t('xYesImSure') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { required, minLength, maxLength, alphaNum, numeric, between } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import * as Constants from '@/constants'
import unitMixin from '@/utils/unitMixin'
import Lottie from '../lottie.vue'
import * as waitingForTankReadingAnimation from '@/assets/images/clock-blue500.json'
import { mapState, mapGetters, mapActions } from 'vuex'
import * as successAnimation from '@/assets/images/manage-subscription-success.json'
import SubscriptionsModal from './Subscription/SubscriptionsModal.vue'
import AddressSearchModals from '../Common/Address/AddressSearchModals.vue'
import { openModal } from '../../utils/mixins'

const monthInRange = (value, vm) => value >= 1 && value <= 12

export default {
  props: ['enrollmentNoSubscription', 'deviceType', 'apparatusId'],
  mixins: [unitMixin, validationMixin],
  components: { Lottie, AddressSearchModals, SubscriptionsModal },
  created() {
    this.VERTICAL = 'Vertical'
    this.HORIZONTAL = 'Horizontal'
    this.PROPANE = 'Propane'
    this.HEATINGOIL = 'HeatingOil'
  },
  data() {
    return {
      consent: null,
      awaitingSearch: false,
      bGClassVerifyTankReading: null,
      capsToLoad: null,
      currentWizardWindow: null,
      editingTankAddress: false,
      enrollingTank: false,
      finishingSetup: false,
      freeformFuelProvider: null,
      fuelProviderId: null,
      fuelProviderName: null,
      fuelProviderResults: null,
      fuelUseHeating: false,
      fullTankDeviceId: null,
      initialAddress: null,
      isValidAddress: true,
      loadingTankCapacities: false,
      selectedTankUtilFuelUses: null,
      tankAddress: null,
      tankApparatusId: null,
      tankCapacities: [],
      tankName: null,
      tankReadingLevel: null,
      tankLevelValidationDone: null,
      userEnteredTankDeviceId: null,
      userEnteredTankDialLevel: null,
      userSelectedFuelType: null,
      userSelectedTankCapacity: null,
      userSelectedTankOrien: null,
      validatingId: false,
      verifyTankReadingSuccess: null,
      waitingForTankReadingAnimationOptions: { animationData: waitingForTankReadingAnimation, loop: true },
      tankDeviceType: null,
      helpStep1: 0,
      helpStep2: 0,
      helpStep3: 0,
      helpStep4: 0,
      helpStep5: 0,
      helpStep6: 0,
      helpStep7: 0,
      helpStep8: 0,
      helpStep9: 0,
      helpStep10: 0,
      helpReadingNotReceived: 0,
      existingPaymentInfo: null,
      useExistingPaymentInfo: true,
      creditCardNumber: null,
      expirationMonth: null,
      expirationYear: null,
      cvv: null,
      updatingPaymentInfo: false,
      subscribingProduct: false,
      errorMessages: [],
      showValidationBanner: false,
      tankSubscriptionName: '',
      tankSubscriptionCost: null,
      tankSubscriptionProductId: null,
      successAnimationOptions: { animationData: successAnimation, loop: false },
      loadingSubscriptionModal: true,
      activeModal: '',
      showEnrollTankApparatusError: false,
      enrollTankApparatusErrorMessage: null,
      showValidateDeviceIdError: false,
      validateDeviceIdErrorMessage: null,
      showTankReadingError: false,
      tankReadingErrorMessage: null,
      showFinishSetupError: false,
      finishSetupErrorMessage: null,
      showUpdatePaymentInfoError: false,
      updatePaymentInfoErrorMessage: null,
      showSubscribeProductError: false,
      subscribeProductErrorMessage: null,
      showTankUsageUnfinishedErrorMessage: false,
      existingSubscriptions: [],
      basicHSB: null,
      getTankReadingCancelled: false,
      subscriptionPollingInfo: null
    }
  },
  computed: {
    ...mapState({
      ...mapState({
        currentApparatusDetails: state => state.apparatus.currentApparatusDetails
      }),
      apparatuses: state => state.apparatus.apparatuses,
      accountProfile: state => state.account.accountProfile,
      currentAppConfig: state => state.application.currentAppConfig
    }),
    wifiTankDeviceType() {
      return Constants.TankUtilityWifiDeviceType
    },
    lteV2TankDeviceType() {
      return Constants.TankUtilityLteDeviceTypeV2
    }
  },
  validations: {
    userEnteredTankDeviceId: {
      required,
      alphaNum,
      minLength: minLength(8),
      maxLength: maxLength(10)
    },
    tankName: {
      required,
      minLength: 1
    },
    userSelectedTankCapacity: {
      required
    },
    userEnteredTankDialLevel: {
      numeric,
      between: between(1, 99)
    },
    cvv: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(4),
      numeric
    },
    expirationMonth: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(2),
      numeric,
      monthInRange
    },
    expirationYear: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(2),
      numeric
    },
    creditCardNumber: {
      required,
      minLength: minLength(15),
      maxLength: maxLength(16),
      numeric
    },
    consent: {
      required,
      Boolean
    }
  },
  methods: {
    openAddressSearchModal() {
      // need to hide the enrollment modals before opening validation to prevent enrollment modals overriding validation modals
      this.$bvModal.hide('tank-enrollment-step-2')
      this.editingTankAddress = true
      this.$nextTick(() => {
        this.$refs.tankEnrollmentAddressSearchModalsRef.openAddressFormModal()
      })
    },
    onAddressValidationClose() {
      this.editingTankAddress = false
      this.$bvModal.show('tank-enrollment-step-2')
    },
    updateFuelMonitorAddress(newAddress, responseOptions) {
      this.editingTankAddress = false
      // Cast to be correct type for enrollment
      this.tankAddress = {
        city: newAddress.city,
        contacts: this.accountProfile.address.contacts, // Carry account contacts from profile
        country: newAddress.countryCode,
        line1: newAddress.address1,
        line2: newAddress.address2 ? newAddress.address2 : null,
        postalCode: newAddress.postalCode,
        region: newAddress.state,
        type: this.accountProfile.address.type // Carry address type from profile
      }
      this.editingTankAddress = false
      this.$bvModal.show('tank-enrollment-step-2')
      responseOptions.closeAddressModals()
    },
    validFuelMonitorId(fuelMonitorDeviceId) {
      return fuelMonitorDeviceId.length === 8 || fuelMonitorDeviceId.length === 10
    },
    wifiSetupNavigation() {
      if (
        this.tankDeviceType == Constants.TankUtilityWifiDeviceType ||
        this.tankDeviceType == Constants.TankUtilityLteDeviceTypeV1
      ) {
        this.$bvModal.show('tank-enrollment-step-9')
        this.helpStep9++
      } else {
        this.$bvModal.show('tank-enrollment-step-5')
        this.helpStep5++
      }
    },
    createApparatusAndProceed() {
      this.enrollingTank = true
      let enrollRequest = {
        organizationId: this.accountProfile.organizationId,
        deviceId: this.fullTankDeviceId,
        name: this.tankName,
        address: this.tankAddress,
        deviceType: this.tankDeviceType
      }
      this.$store
        .dispatch('enrollTankUtilityApparatus', enrollRequest)
        .then(response => {
          this.showEnrollTankApparatusError = false
          this.$bvModal.show('tank-enrollment-step-3')
          this.enrollingTank = false
          this.tankApparatusId = response.data.apparatusId
        })
        .catch(error => {
          this.enrollingTank = false
          if (error.response.status == 409) {
            this.enrollTankApparatusErrorMessage = this.$t('xTankHasAlreadyBeenEnrolled')
          } else {
            this.enrollTankApparatusErrorMessage = this.$t('xErrorEnrollingTankTryAgain')
          }
          this.showEnrollTankApparatusError = true
        })
    },
    onNext() {
      this.createApparatusAndProceed()
      this.editingTankAddress = false
      this.helpStep3++
    },
    validateDeviceId() {
      if (!this.userEnteredTankDeviceId) {
        this.validateDeviceIdErrorMessage = this.$t('xYouMustEnterAValidDeviceIdToContinue')
        this.showValidateDeviceIdError = true
        return false
      } else this.showValidateDeviceIdError = false
      this.validatingId = true
      this.$store
        .dispatch('validateTankDeviceId', this.userEnteredTankDeviceId)
        .then(response => {
          this.validatingId = false
          if (response.status == 200 && response.data.isValid) {
            if (response.data.fullDeviceId) this.fullTankDeviceId = response.data.fullDeviceId
            if (response.data.tankName) this.tankName = response.data.tankName
            if (response.data.tankAddress) this.tankAddress = _.cloneDeep(response.data.tankAddress)
            if (response.data.deviceType) this.tankDeviceType = response.data.deviceType
            this.$bvModal.show('tank-enrollment-step-2')
            this.showValidateDeviceIdError = false
          } else {
            let errorMessage = ''
            switch (response.data.validationCode) {
              case Constants.TankDeviceIdValidationCode_AlreadyEnrolled:
                this.validateDeviceIdErrorMessage = this.$t('xDeviceIdBelongsToAnExistingAccount')
                this.showValidateDeviceIdError = true
                break
              case Constants.TankDeviceIdValidationCode_NotFound:
                this.validateDeviceIdErrorMessage = this.$t('xDeviceIdDoesnotExist')
                this.showValidateDeviceIdError = true
                break
              case Constants.TankDeviceIdValidationCode_WiFiNotDeployed:
                this.showValidateDeviceIdError = false
                this.$bvModal.show('wifi-tank-setup')
                break
              case Constants.TankDeviceIdValidationCode_DisabledDealerManaged:
                this.validateDeviceIdErrorMessage = response.data.message
                this.showValidateDeviceIdError = true
                break
              case Constants.TankDeviceIdValidationCode_DisabledNonDealerManaged:
                this.validateDeviceIdErrorMessage = response.data.message
                this.showValidateDeviceIdError = true
                break
            }
          }
          this.helpStep1++
        })
        .catch(error => {
          this.validatingId = false
          this.validateDeviceIdErrorMessage = error.response.data
          this.showValidateDeviceIdError = true
        })
    },
    setSubscriptionPollingInfo(newSubInfo) {
      this.subscriptionPollingInfo = newSubInfo
    },
    resetInfo() {
      this.consent = null
      this.bGClassVerifyTankReading = null
      this.editingTankAddress = false
      this.finishingSetup = false
      this.fullTankDeviceId = null
      this.isValidAddress = true
      this.tankAddress = this.accountProfile && this.accountProfile.address ? this.accountProfile.address : null
      this.tankLevelValidationDone = null
      this.tankName = null
      this.userEnteredTankDeviceId = null
      this.userEnteredTankDialLevel = null
      this.userSelectedFuelType = null
      this.userSelectedTankCapacity = null
      this.userSelectedTankOrien = null
      this.validatingId = false
      this.verifyTankReadingSuccess = null
      this.tankDeviceType = null
      this.helpStep1 = 0
      this.helpStep2 = 0
      this.helpStep3 = 0
      this.helpStep4 = 0
      this.helpStep5 = 0
      this.helpStep6 = 0
      this.helpStep7 = 0
      this.helpStep8 = 0
      this.helpStep9 = 0
      this.helpStep10 = 0
      this.helpReadingNotReceived = 0
      this.existingPaymentInfo = null
      this.useExistingPaymentInfo = true
      this.creditCardNumber = null
      this.expirationMonth = null
      this.expirationYear = null
      this.cvv = null
      this.updatingPaymentInfo = false
      this.subscribingProduct = false
      this.errorMessages = []
      this.showValidationBanner = false
      this.tankSubscriptionName = ''
      this.tankSubscriptionCost = null
      this.tankSubscriptionProductId = null
      this.showEnrollTankApparatusError = false
      this.enrollTankApparatusErrorMessage = null
      this.showValidateDeviceIdError = false
      this.validateDeviceIdErrorMessage = null
      this.showTankReadingError = false
      this.tankReadingErrorMessage = null
      this.showFinishSetupError = false
      this.finishSetupErrorMessage = null
      this.showUpdatePaymentInfoError = false
      this.updatePaymentInfoErrorMessage = null
      this.showSubscribeProductError = false
      this.subscribeProductErrorMessage = null
      this.showTankUsageUnfinishedErrorMessage = false
      this.existingSubscriptions = []
      this.getTankReadingCancelled = true
      this.tankApparatusId = null
      //reset tank use dictionary
      this.loadFuelUses()

      this.$v.$reset()
    },
    async loadFuelUses() {
      let consumptionTypes = null
      await this.$store
        .dispatch('getTankUtilityConsumptionTypes')
        .then(response => {
          if (response.status == 200) {
            consumptionTypes = response.data
          }
        })
        .catch(error => {
          //This toast is not being replaced with an alert,
          //because this function is not called from a modal
          this.validateError = error.response.data
          this.$store.dispatch('displayToast', {
            title: this.$t('xError'),
            message: this.validateError.message,
            variant: 'danger'
          })
        })

      consumptionTypes.forEach(element => (element.selected = null))
      this.selectedTankUtilFuelUses = null
      this.selectedTankUtilFuelUses = _.clone(consumptionTypes)
    },
    checkFuelUseSelected() {
      const isNull = element => element.selected === null
      let isError = this.selectedTankUtilFuelUses.some(isNull)
      this.showTankUsageUnfinishedErrorMessage = isError
      if (!isError) {
        this.$bvModal.show('tank-enrollment-step-10')
      }
    },
    areYouSure(currentWizardWindow) {
      this.currentWizardWindow = currentWizardWindow
      this.$bvModal.show('confirm-close-wizard')
    },
    async closeEnrollmentModals() {
      if (this.activeModal) {
        this.$appInsights.trackEvent({
          name: 'apparatus-enrollment-cancel',
          properties: { type: 'tankUtility', section: this.activeModal }
        })
      }

      // capture before resetInfo() clears this.tankApparatusId
      const apparatusIdForPolling = this.tankApparatusId

      this.resetInfo()

      //close all enrollment modals:
      this.$bvModal.hide('tank-enrollment-step-1')
      this.$bvModal.hide('tank-enrollment-step-2')
      this.$bvModal.hide('tank-enrollment-step-3')
      this.$bvModal.hide('tank-enrollment-step-4')
      this.$bvModal.hide('tank-enrollment-step-5')
      this.$bvModal.hide('tank-enrollment-step-6')
      this.$bvModal.hide('tank-enrollment-step-7')
      this.$bvModal.hide('tank-enrollment-step-8')
      this.$bvModal.hide('tank-enrollment-step-9')
      this.$bvModal.hide('tank-enrollment-step-10')
      this.$bvModal.hide('tank-enrollment-loading-subscription')
      this.$bvModal.hide('tank-enrollment-step-11')
      this.$bvModal.hide('tank-enrollment-step-11-existing-apparatuses')
      this.$bvModal.hide('tank-enrollment-step-12')
      this.$bvModal.hide('tank-enrollment-success')
      this.$bvModal.hide('confirm-close-wizard')

      this.activeModal = ''

      this.openModal('globalSpinnerModalMedium')
      await this.$store.dispatch('getApparatusesSilent')

      if (!!this.subscriptionPollingInfo && this.accountProfile.organizationId) {
        await this.pollForSubmissionUpdate(
          'getSubscriptionDetails',
          this.accountProfile.organizationId,
          subscriptionData => {
            if (subscriptionData && subscriptionData.subscriptions) {
              const subscriptionForApparatus = subscriptionData.subscriptions.find(sub => {
                const hasApparatus = sub.apparatuses?.some(subApp => subApp.apparatusId === apparatusIdForPolling)
                const isProductMatch = sub.product.productId === this.subscriptionPollingInfo.productId

                return hasApparatus && isProductMatch
              })

              return !!subscriptionForApparatus
            }

            return false
          },
          'md'
        )
          .then(pollingResult => {
            if (pollingResult) {
              // clear existing pending changes just in case
              this.$store.dispatch('deletePendingSubscriptionChanges')
            } else {
              const pendingChange = {
                // since this is specific to enrollment, there should only be one id we care about
                // If multiple are subscribed at once, they will still be on the same new (and therefor only) sub
                apparatusIds: [apparatusIdForPolling],
                pendingProductId: this.subscriptionPollingInfo.productId,
                isPendingCancel: false
              }
              this.$store.dispatch('addPendingSubscriptionChanges', pendingChange)
            }
          })
          .catch(() => {
            this.$store.dispatch('displayToast', {
              title: this.$t('xSomethingWentWrong'),
              message: this.$t('xWaitAndTryAgainErrorText'),
              variant: 'danger'
            })
          })
      }

      this.closeModal('globalSpinnerModalMedium')
    },
    getTankReading() {
      // Show reading not received message if waiting for reading for more than 60 seconds.
      let showTimeoutMessage = true
      setTimeout(() => {
        if (showTimeoutMessage) {
          this.helpReadingNotReceived++
          this.$bvModal.show('tank-enrollment-tank-reading-not-received')
          showTimeoutMessage = false
        }
      }, 60000)

      this.$store
        .dispatch('getTankReading', this.tankApparatusId)
        .then(response => {
          if (!this.getTankReadingCancelled) {
            showTimeoutMessage = false
            this.showTankReadingError = false
            this.tankReadingLevel = response.data.reading
            this.$bvModal.show('tank-enrollment-step-7')
          }
        })
        .catch(error => {
          if (!this.getTankReadingCancelled) {
            showTimeoutMessage = false
            if (error.response.status != 408) {
              this.tankReadingErrorMessage = error.response.data
              this.showTankReadingError = true
            }
            this.helpReadingNotReceived++
            this.$bvModal.show('tank-enrollment-tank-reading-not-received')
          }
        })
    },
    async loadTankCapacities() {
      this.loadingTankCapacities = true
      this.capsToLoad = []
      this.tankCapacities = []
      await this.getTankCapacities(this.userSelectedFuelType, this.userSelectedTankOrien)
      this.capsToLoad.forEach(element => {
        this.tankCapacities.push({ value: element.value, text: this.convertCapacityLabel(element.text) })
      })
      this.loadingTankCapacities = false
      this.$bvModal.show('tank-enrollment-step-4')
    },
    async getTankCapacities(fuelType, orientation) {
      await this.$store
        .dispatch('getTankUtilityTankSizes', {
          fuelType: fuelType,
          orientation: orientation
        })
        .then(response => {
          if (response.status == 200) {
            this.capsToLoad = response.data
          }
        })
        .catch(error => {
          //This toast is staying due to user not able to do
          //anything if cosmos fails to return capacities
          this.validateSNError = error.response.data
          this.$store.dispatch('displayToast', {
            title: this.$t('xError'),
            message: this.validateSNError.message,
            variant: 'danger'
          })
        })
    },
    handleAnimation(anim) {
      this.anim = anim
    },
    tankMonitorInstallVideoUrl() {
      if (
        this.currentAppConfig &&
        this.currentAppConfig.configurations &&
        this.currentAppConfig.configurations[Constants.TankMonitorInstallVideoUrlConfig]
      ) {
        return this.currentAppConfig.configurations[Constants.TankMonitorInstallVideoUrlConfig]
      }
      return ''
    },
    trackClick(actionToTrack) {
      this.$appInsights.trackEvent({
        name: 'tank-enrollment-previous-button-click',
        properties: {
          action: actionToTrack
        }
      })
    },
    verifyTankReading() {
      this.verifyTankReadingSuccess =
        this.userEnteredTankDialLevel >= this.tankReadingLevel - 5 &&
        this.userEnteredTankDialLevel <= this.tankReadingLevel + 5
    },
    tryEnterTankLevelAgain() {
      this.verifyTankReadingSuccess = null
      this.tankLevelValidationDone = null
      this.userEnteredTankDialLevel = null
      this.$v.$reset()
      document.getElementById('tankDialLevel').focus()
    },
    addTag(index, value) {
      this.selectedTankUtilFuelUses[index].selected = value
    },
    getVariant(selected) {
      if (selected) return 'warning'
      else return 'outline-warning'
    },
    typeAheadSearch() {
      if (this.timeout) {
        this.awaitingSearch = false
        clearTimeout(this.timeout)
      }
      if (this.freeformFuelProvider.length < 3) {
        this.fuelProviderSearchResults = []
        return
      }
      if (!this.awaitingSearch) {
        var request = {
          name: this.freeformFuelProvider,
          //region: this.accountProfile.address.region,
          pageNumber: 1,
          pageSize: 10
        }
        this.timeout = setTimeout(() => {
          this.$store
            .dispatch('typeAheadFuelProviderSearch', request)
            .then(response => {
              if (response.status == 204) this.fuelProviderResults = []
              else this.fuelProviderResults = response.data
            })
            .catch(error => {
              this.fuelProviderResults = []
            })
            .finally(() => {
              this.awaitingSearch = false
            })
        }, 1000)
      }
      this.awaitingSearch = true
    },
    setFuelProvider(provider) {
      this.fuelProviderId = provider.id
      this.fuelProviderName = provider.name
      this.freeformFuelProvider = null
      this.hideResults()
    },
    hideResults() {
      this.fuelProviderResults = null
    },
    finishSetup() {
      this.finishingSetup = true
      this.loadingSubscriptionModal = true
      let consumptionTypes = {}
      this.selectedTankUtilFuelUses.forEach(element => {
        consumptionTypes[element.type] = element.selected
      })

      let request = {
        apparatusId: this.tankApparatusId,
        fuelTankCapacity: this.userSelectedTankCapacity,
        fuelTankFuelType: this.userSelectedFuelType,
        fuelTankOrientation: this.userSelectedTankOrien,
        consumptionTypes: consumptionTypes,
        fuelDealerId: this.fuelProviderId
      }

      this.$store
        .dispatch('updateTankUtilityApparatus', request)
        .then(response => {
          this.loadSubscriptionModal()
        })
        .catch(error => {
          this.finishingSetup = false
          this.finishSetupErrorMessage = this.$t('xErrorUpdatingTankPleaseTryAgain')
          this.showFinishSetupError = true
        })
        .finally(() => {
          this.finishingSetup = false
        })
    },
    updatePaymentInfo() {
      this.updatingPaymentInfo = true
      let addPaymentModel = {
        organizationId: this.accountProfile.organizationId,
        cardNumber: this.creditCardNumber,
        cvv: this.cvv,
        expirationMonth: this.expirationMonth,
        expirationYear: '20' + this.expirationYear
      }
      this.$store.dispatch('storeSubscriptionTermsConsent', this.accountProfile.organizationId).then(response => {})
      if (this.existingPaymentInfo) {
        let removePaymentModel = {
          organizationId: this.accountProfile.organizationId,
          paymentId: this.existingPaymentInfo.id
        }
        this.$store
          .dispatch('addBillingAccountPaymentMethod', addPaymentModel)
          .then(response => {
            this.$store
              .dispatch('removeBillingAccountPaymentMethod', removePaymentModel)
              .then(response => {
                this.useExistingPaymentInfo = true
                this.updatingPaymentInfo = false
                this.showUpdatePaymentInfoError = false
              })
              .catch(error => {
                this.updatePaymentInfoErrorMessage = this.$t('xFailedToRemoveExistingPaymentInformation')
                this.showUpdatePaymentInfoError = true
                this.updatingPaymentInfo = false
              })
          })
          .catch(error => {
            this.errorMessages = []
            if (error.response.data.errors) {
              if (error.response.data.errors.CardNumber || error.response.data.errors.cardNumber) {
                this.showValidationBanner = true
                this.errorMessages.push(this.$t('xCCIsInvalid'))
              }
              if (error.response.data.errors.Cvv || error.response.data.errors.cvv) {
                this.showValidationBanner = true
                this.errorMessages.push(this.$t('xCvvInvalid'))
              }
              if (error.response.data.errors.ExpirationMonth || error.response.data.errors.expirationMonth) {
                this.showValidationBanner = true
                this.errorMessages.push(this.$t('xExpirationMonthInvalid'))
              }
              if (error.response.data.errors.ExpirationYear || error.response.data.errors.expirationYear) {
                this.showValidationBanner = true
                this.errorMessages.push(this.$t('xExpirationYearInvalid'))
              }
              if (error.response.data.errors.billing || error.response.data.errors.Billing) {
                this.updatePaymentInfoErrorMessage = error.response.data.errors.billing
                  ? error.response.data.errors.billing
                  : error.data.response.errors.Billing
                this.showUpdatePaymentInfoError = true
              }
            } else {
              this.updatePaymentInfoErrorMessage = this.$t('xFailedToAddPaymentMethod')
              this.showUpdatePaymentInfoError = true
            }
            this.updatingPaymentInfo = false
          })
      } else {
        this.$store
          .dispatch('addBillingAccountPaymentMethod', addPaymentModel)
          .then(response => {
            this.$store
              .dispatch('getActivePaymentMethod', this.accountProfile.organizationId)
              .then(response => {
                if (response) {
                  this.updatingPaymentInfo = false
                  this.existingPaymentInfo = response.data
                  this.useExistingPaymentInfo = true
                  this.showUpdatePaymentInfoError = false
                } else {
                  this.updatingPaymentInfo = false
                  this.finishingSetup = false
                  this.existingPaymentInfo = null
                  this.useExistingPaymentInfo = false
                }
              })
              .catch(error => {
                this.updatingPaymentInfo = false
                this.finishingSetup = false
                this.existingPaymentInfo = null
                this.useExistingPaymentInfo = false
              })
          })
          .catch(error => {
            this.errorMessages = []
            if (error.response.data.errors) {
              if (error.response.data.errors.CardNumber || error.response.data.errors.cardNumber) {
                this.showValidationBanner = true
                this.errorMessages.push(this.$t('xCCIsInvalid'))
              }
              if (error.response.data.errors.Cvv || error.response.data.errors.cvv) {
                this.showValidationBanner = true
                this.errorMessages.push(this.$t('xCvvInvalid'))
              }
              if (error.response.data.errors.ExpirationMonth || error.response.data.errors.expirationMonth) {
                this.showValidationBanner = true
                this.errorMessages.push(this.$t('xExpirationMonthInvalid'))
              }
              if (error.response.data.errors.ExpirationYear || error.response.data.errors.expirationYear) {
                this.showValidationBanner = true
                this.errorMessages.push(this.$t('xExpirationYearInvalid'))
              }
              if (error.response.data.errors.billing || error.response.data.errors.Billing) {
                this.updatePaymentInfoErrorMessage = error.response.data.errors.billing
                  ? error.response.data.errors.billing
                  : error.data.response.errors.Billing
                this.showUpdatePaymentInfoError = true
              }
            } else {
              this.updatePaymentInfoErrorMessage = this.$t('xFailedToAddPaymentMethod')
              this.showUpdatePaymentInfoError = true
            }
            this.updatingPaymentInfo = false
          })
      }
    },
    async loadSubscriptionModal() {
      const tank = this.apparatuses?.find(app => app?.apparatusId === this.apparatusId)
      if (!this.tankApparatusId) {
        this.tankApparatusId = this.apparatusId
      }
      if (!this.tankDeviceType) {
        this.$store.dispatch('displayToast', {
          title: this.$t('xError'),
          message: this.$t('xSomethingUnexpectedWentWrong'),
          variant: 'danger'
        })
      }

      if (this.tankDeviceType == Constants.TankUtilityLteDeviceTypeV2 && this.accountProfile?.organizationId) {
        this.$bvModal.show('subscription-modal-tank')
      } else if (
        this.tankDeviceType == Constants.TankUtilityLteDeviceTypeV1 ||
        this.tankDeviceType == Constants.TankUtilityWifiDeviceType
      ) {
        this.$bvModal.show('tank-enrollment-success')
      }
    },
    // NOTE - this functions are used to track/monitor when the user (somehow) exists the enrollment process before completing the subscription application
    // portion of the enrollment
    // NOTE - for more information about the beforeunload event, please refer to this: https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event#usage_notes
    onLeaveBeforeSubscriptionApplication() {
      window.removeEventListener('beforeunload', this.onLeaveBeforeSubscriptionApplication)
      this.$appInsights.trackEvent({
        name: 'apparatus-enrollment-cancel',
        properties: { type: 'tankUtility', section: 'subscription-purchase' }
      })
    },
    OnShowSubscriptionModal() {
      this.activeModal = 'subscription-purchase'
      window.addEventListener('beforeunload', this.onLeaveBeforeSubscriptionApplication)
    },
    OnHideSubscriptionModal() {
      window.removeEventListener('beforeunload', this.onLeaveBeforeSubscriptionApplication)
    },
    removeExtraChars(testhook) {
      return testhook
        .split(' ')
        .join('')
        .split('/')
        .join('')
    },
    onContinueFromSubscription() {
      if (this.existingSubscriptions?.length > 0) {
        this.addApparatusToSubscription()
      } else {
        this.$bvModal.show('tank-enrollment-step-12')
      }
    },
    addApparatusToSubscription() {
      this.subscribingProduct = true
      let appId = null
      if (this.apparatusId) {
        appId = this.apparatusId
      } else {
        appId = this.tankApparatusId
      }
      let apparatusIdList = []
      this.existingSubscriptions[0].apparatuses.forEach(apparatus => {
        apparatusIdList.push(apparatus.apparatusId)
      })
      apparatusIdList.push(appId)
      let store = ''
      switch (this.existingSubscriptions[0].store) {
        case 0:
          store = 'Apple'
          break
        case 1:
          store = 'Google'
          break
        case 2:
          store = 'Web'
          break
        case 3:
          store = 'Dealer'
          break
        default:
          break
      }
      this.$store
        .dispatch('updateSubscriptionApparatuses', {
          organizationId: this.accountProfile.organizationId,
          store: store,
          productId: this.existingSubscriptions[0].product.productId,
          apparatusIds: apparatusIdList
        })
        .then(response => {
          // If there is a pending change and we are trying to update the current subscription, override the pending change.
          if (this.existingSubscriptions[0].status === Constants.SubscriptionDetailPendingProductChange) {
            // Indicate that the currently active subscription product is the one we want. Cancel out the pending change.
            return this.$store
              .dispatch('createPurchaseIntent', {
                productId: this.existingSubscriptions[0].product.productId,
                organizationId: this.accountProfile.organizationId,
                apparatusIds: apparatusIdList
              })
              .then(() => {
                return this.$store.dispatch('updateSubscriptionProduct', {
                  organizationId: this.accountProfile.organizationId,
                  productId: this.existingSubscriptions[0].product.productId
                })
              })
          }
        })
        .then(() => {
          this.subscribingProduct = false
          this.showSubscribeProductError = false
          this.$bvModal.show('tank-enrollment-success')
        })
        .catch(error => {
          this.subscribingProduct = false
          this.showSubscribeProductError = true
          if (error?.response?.data?.message) {
            this.subscribeProductErrorMessage = error.response.data.message
          } else {
            this.subscribeProductErrorMessage = this.$t('xFailedToSetTankSub')
          }
        })
    }
  },
  watch: {
    accountProfile: function(newVal, oldVal) {
      if (newVal) {
        this.tankAddress = _.cloneDeep(newVal.address)
        this.initialAddress = _.cloneDeep(newVal.address)
      }
    },
    deviceType: function(newVal, oldVal) {
      this.tankDeviceType = newVal
    },
    enrollmentNoSubscription: function(newVal, oldVal) {
      this.loadingSubscriptionModal = true
      this.loadSubscriptionModal()
    },
    apparatusId: function(newVal, oldVal) {
      this.tankApparatusId = newVal
    }
  },
  mounted() {
    this.loadFuelUses()
    if (this.accountProfile) {
      this.tankAddress = _.cloneDeep(this.accountProfile.address)
      this.initialAddress = _.cloneDeep(this.accountProfile.address)
    }
    if (!this.countryStates || !this.countryStates.value) this.$store.dispatch('getCountrySubdivisions')
    if (!this.currentAppConfig) this.$store.dispatch('getApplicationConfiguration', 'Any')
    if (this.deviceType) {
      this.tankDeviceType = this.deviceType
    }
    if (this.apparatusId) this.tankApparatusId = this.apparatusId
    if (this.enrollmentNoSubscription) {
      this.loadingSubscriptionModal = true
      this.loadSubscriptionModal()
    }
  }
}
</script>
<style scoped lang="scss">
#subscription-modal-tank {
  @media (min-width: 576px) {
    .modal-dialog {
      max-width: 200px !important;
    }
  }
  @media (min-width: 800px) {
    .modal-dialog {
      max-width: 400px !important;
    }
  }
}

.bullet-points {
  li {
    margin-bottom: 0.35em;
  }
}

.shouldnt-take-long {
  text-align: center;
}

.verify-reading {
  font-style: italic;
  text-align: center;
}

.check-cellular {
  text-align: center;
}

.modal-header {
  padding: 160px 160px;
}

.bold-text {
  font-weight: bold;
}

li {
  margin: 0px 0;
}

.tu-help-alert {
  background-color: var(--yellow-200);
  color: var(--carbon-900);
  border: solid 1px var(--yellow-400);
}

.invalid-feedback {
  order: 2;
}
</style>
<style scoped lang="scss">
h1 {
  font-weight: normal;
  line-height: 1.15;
}

.sub-radio-dot {
  font-size: 0.875rem !important;
}

.card-title {
  margin-bottom: 0;
}

.selected {
  border: 1px solid var(--brand-400);
  background: white;
  box-shadow: 0px 0px 10px var(--brand-400);
}
</style>
